import { render, staticRenderFns } from "./PlanTag.vue?vue&type=template&id=69a9c09d"
import script from "./PlanTag.vue?vue&type=script&lang=ts"
export * from "./PlanTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports